/**
 * Meta Ads area is available when the meta-ads API base URL is configured.
 */
export function isMetaAdsExperienceAvailable(isApiConfigured) {
  return Boolean(isApiConfigured);
}
